module.exports = __webpack_public_path__ + "static/media/no_foto_perfil.e2b82420.svg";